import * as types from '../actions/types';

const initialState = {
    list: {},
    keys: {},
};

const translations = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.TRANSLATIONS_LIST_CHANGED: {
            return {
                ...state,
                list: payload,
            };
        }
        case types.TRANSLATIONS_KEYS_CHANGED: {
            return {
                ...state,
                keys: payload,
            };
        }
        default:
            return state;
    }
};

export default translations;
